// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__hBgWN","inputWrap":"Table_inputWrap__33PzK","col":"Table_col__LyMj-","bmiTooltip":"Table_bmiTooltip__34dRD"};